<div class="container">
  <section>
    <img src="assets/images/tick.png" alt="Angular Logo">
    <p class="thank">Thank You ! </p>
    <p>Your membership application has been submitted successfully.</p>
  </section>

</div>